import { useSelector } from 'react-redux';
import NoteListCardItem from './items/NoteListCardItem';

const OffcanvasNotes = ({handleNoteDetails, }) => {

  // @ts-ignore
  const notes = useSelector((state) => state.notes.value);

  const handleNoteClick = (note) => {
    handleNoteDetails(note.id);
  };

  return (
    <>
    <div
        className="offcanvas offcanvas-start"
        tabIndex={-1}
        id="offcanvas-notes"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
            Notes
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div>
          <div className="y-scroll w-100 ">
                <div className="p-1">
                  <div>{notes.length === 0 && `no notes found yet`}</div>
                  <div>
                    {notes.map((note) => {
                      return (
                        <NoteListCardItem
                          key={note.id}
                          item={note}
                          type="note"
                          onClick={handleNoteClick}
                          data-bs-dismiss="offcanvas"
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OffcanvasNotes